import ShareholderTicket from './shareholder_ticket';

export default ShareholderTicket;
